var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "var(--icon-color)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1529 4384 c-771 -139 -1217 -944 -926 -1668 45 -113 109 -221 181 -309 47 -57 1128 -1110 1663 -1619 65 -62 75 -68 113 -68 38 0 48 6 114 68 757 726 1615 1561 1662 1619 263 320 342 774 203 1171 -174 496 -634 822 -1159 822 -288 0 -552 -92 -767 -267 l-53 -43 -53 43 c-115 94 -279 180 -417 220 -160 47 -402 60 -561 31z m2062 -208 c305 -64 566 -268 704 -551 83 -169 100 -245 100 -450 0 -146 -3 -182 -23 -255 -31 -115 -118 -289 -189 -377 -58 -73 -1606 -1573 -1623 -1573 -16 0 -1574 1511 -1618 1569 -23 31 -62 94 -86 141 -263 510 -57 1134 459 1385 144 71 247 97 403 103 289 11 517 -72 747 -273 85 -73 108 -70 219 29 171 152 348 236 558 266 85 12 256 5 349 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeader);
export default __webpack_public_path__ + "static/media/like_header.2c536b89549e4d819263e57db5d327ca.svg";
export { ForwardRef as ReactComponent };